<template>
    <v-dialog width="550px" v-model="workingCalendarIsOpen">
        <v-card elevation="0" >
            <v-card-title class="d-flex justify-center">
                <h2 class="
                        d-flex
                        justify-center
                        font-weight-light
                        primary--text
                    ">
                    Día Festivo
                </h2>
            </v-card-title>
            <v-card-text class="pa-1">
                <v-card elevation="0" class="mx-6 pt-2 px-4">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Título
                        </h4>
                    </v-row> -->
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-row>
                        <v-col cols="12">
                            <v-text-field 
                                v-model="form.name" 
                                label="nombre" 
                                prepend-icon="mdi-form-textbox"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card elevation="0" class="mx-6 pt-2 px-4">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Descripción
                        </h4>
                    </v-row> -->
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-row>
                        <v-col cols="12">
                            <v-textarea 
                                v-model="form.description" 
                                label="Descripción" 
                                prepend-icon="mdi-form-textarea"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card elevation="0" class="mx-6 pt-2 px-4">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Fecha
                        </h4>
                    </v-row> -->
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-row>
                        <v-col cols="12">
                            <v-date-picker
                                v-model="form.date"
                                full-width
                                class="mt-4 elevation-0"
                                event-color="red"
                            >
                                <v-row no-gutters class="d-flex justify-center">
                                    <v-col
                                        cols="6"
                                        class="d-flex justify-center"
                                    >
                                        <v-btn
                                            outlined
                                            @click="setToday()"
                                            color="yellow darken-3"
                                        >
                                            Hoy
                                            <v-icon right dark>
                                                mdi-calendar-today
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        class="d-flex justify-center"
                                    >
                                        <v-btn
                                            outlined
                                            @click="setNull()"
                                            color="red darken-1"
                                        >
                                            Borrar
                                            <v-icon right dark>
                                                mdi-delete-clock-outline
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-date-picker>
                        </v-col>
                    </v-row>
                </v-card>
            </v-card-text>


            <v-card-actions class="justify-end">
                <v-btn 
                depressed 
                color="success" 
                @click="
                    submit();
                    close();" 
                >
                    Guardar
                </v-btn>
                   
                <v-btn text color="red" @click="close()">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AddBadgeDialog',
    data: () => ({

    }),
    methods: {
        submit(){
            this.$store.dispatch('holidays/createWorkingCalendar');
        },
        setToday() {
            this.form.date = new Date().toISOString().substr(0, 10);
        },
        setNull() {
            this.form.date = null;
        },
        close() {
            this.$store.commit('holidays/workingCalendarIsOpen', false);
        }
    },
    computed:{
        workingCalendarIsOpen: {
            get() {
                return this.$store.state.holidays.workingCalendarObj.isOpen;
            },
            set(value) {
                this.$store.commit('holidays/workingCalendarIsOpen', value);
            }
        },
        ...mapState('holidays',{
            form: (state) => state.workingCalendarObj.workingCalendarForm
        })
    }
};
</script>
